module.exports = __webpack_public_path__ + "img/1.17e3d90f.png";